var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.pins.length
    ? _c(
        "div",
        { staticClass: "pin-list" },
        _vm._l(_vm.pins, function (p) {
          return _c(
            "div",
            { key: p.key, staticClass: "pin-row" },
            [
              _c(
                "span",
                { staticClass: "pin-row__cane" },
                [
                  p.deviceSerial
                    ? _c("code", [_vm._v(_vm._s(p.deviceSerial))])
                    : _c("el-tag", { attrs: { type: "info", size: "mini" } }, [
                        _vm._v(_vm._s(_vm.$t("otaPin.allCanes"))),
                      ]),
                ],
                1
              ),
              _c("span", { staticClass: "pin-row__ver" }, [
                _c("strong", [_vm._v(_vm._s(p.appVersion))]),
                p.wirelessVersion
                  ? _c("span", { staticClass: "ota-side" }, [
                      _vm._v(" / wireless " + _vm._s(p.wirelessVersion)),
                    ])
                  : _vm._e(),
              ]),
              p.userEmail
                ? _c("span", { staticClass: "pin-row__user" }, [
                    _c("i", { staticClass: "el-icon-user" }),
                    _vm._v(" " + _vm._s(p.userEmail) + " "),
                  ])
                : _vm._e(),
              p.reason
                ? _c("span", { staticClass: "pin-row__reason" }, [
                    _vm._v("— " + _vm._s(p.reason)),
                  ])
                : _vm._e(),
              _c("span", { staticClass: "pin-row__meta" }, [
                _vm._v(_vm._s(_vm.formatRelative(p.createdAt))),
              ]),
              _vm.removable
                ? _c(
                    "el-button",
                    {
                      staticClass: "pin-row__remove",
                      attrs: {
                        type: "text",
                        size: "mini",
                        icon: "el-icon-delete",
                        loading: _vm.removingKey === p.key,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("remove", p)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("otaPin.delete")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        0
      )
    : _c(
        "div",
        { staticClass: "pin-list-empty" },
        [
          _c("el-tag", { attrs: { type: "info", size: "mini" } }, [
            _vm._v(_vm._s(_vm.$t("otaPin.noPins"))),
          ]),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }